export const HRS_CONFIGURATOR_PATH = "/sales/sandbox/hrs-rack-configurator";
export const HRS_CATALOGUE_PATH = "/sales/catalogue?brand=HRS";
export const HRS_SANDBOX_PATH = "/sales/sandbox";

export function safeHrsReturnPath(value?: string | null) {
  const path = String(value ?? "").trim();
  return path.startsWith("/") && !path.startsWith("//") ? path : null;
}

export function resolveHrsReturnPath(input: { returnTo?: string | null; catalogue?: string | null }) {
  return safeHrsReturnPath(input.returnTo) ??
    (input.catalogue === "1" ? HRS_CATALOGUE_PATH : HRS_SANDBOX_PATH);
}

export function buildHrsConfiguratorPath(input: {
  rackId?: number;
  newProject?: boolean;
  returnTo?: string | null;
  anchor?: string;
}) {
  const params = new URLSearchParams();
  if (input.rackId) params.set("rackId", String(input.rackId));
  if (input.newProject) params.set("new", "1");
  const returnTo = safeHrsReturnPath(input.returnTo);
  if (returnTo) params.set("returnTo", returnTo);
  const query = params.toString();
  return `${HRS_CONFIGURATOR_PATH}${query ? `?${query}` : ""}${input.anchor ? `#${input.anchor}` : ""}`;
}
